import { OrderActionTypes } from "./constants";

const initialState = {
  orders: [],
  selectedOrder: null,
  expandedOrderId: null,
  error: null,
};

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case OrderActionTypes.SET_ORDERS:
      return {
        ...state,
        orders: action.payload,
        error: null,
      };
    case OrderActionTypes.SET_ORDERS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case OrderActionTypes.SET_SELECTED_ORDER:
      return {
        ...state,
        selectedOrder: action.payload,
      };
    case OrderActionTypes.SET_EXPANDED_ORDER:
      return {
        ...state,
        expandedOrderId: action.payload,
      };
    case OrderActionTypes.UPDATE_ORDER:
      return {
        ...state,
        orders: state.orders.map(order => 
          order.id === action.payload.id ? action.payload : order
        ),
      };
    default:
      return state;
  }
} 